<template>
    <div>
        <gmap-autocomplete
            @place_changed="setPlace"
            :style="this.form_style"
        ></gmap-autocomplete>

        <maps
            @marker_move="emmitToParent"
            v-if="this.withmap"
            :style="this.map_style"
            :current_location="this.current_location"
            :center_map="this.$store.state.maps.center_map"
            :markers="this.$store.state.maps.markers"
            :map_type="this.map_type"
            id="maps"
        />
    </div>
</template>

<script>
    /* eslint-disable */
    import maps from "@/components/layouts/Maps.vue";

    let context;
    export default{
        name:"py-maps-autocomplete",
        components:{
            maps
        },
        
        props:{
            withmap:{
                type:Boolean,
                default:true
            },
            map_style:String,
            current_location:{
                type:Boolean,
                default:true
            },
            center_map:Object,
            markers:Array,
            map_type:String,
            form_style:String
        },
        
        data(){
            return {

            }
        },

        methods:{
            setCenterMap(value){
                context.center_map=value;
            },

            setMarkers(value){
                context.markers=value;
            },

            setPlace(place){
                let location=place.geometry.location;
                let markers=[{position:location}]

                //Store State
                context.$store.dispatch("SET_CENTER_MAP",location);
                context.$store.dispatch("SET_MARKERS",markers);

                let geocoder = new google.maps.Geocoder;
                let address = geocoder.geocode({location:location},function(results, status) {
                    if (status === 'OK') {
                        let new_loc=results[0];
                        context.emmitToParent(new_loc);
                    } else {
                        context.$notify({
                            group:"error",
                            title:"Error Notification",
                            text:"Geocoder failed due to: " + status
                        })
                    }
                });
            },

            async emmitToParent(location){
                context.$emit("marker-move",location);
            }
        },


        async mounted(){
            context=this;

            context=this;
            if(!context.current_location){
                context.$store.dispatch("SET_CENTER_MAP",context.center_map);
                context.$store.dispatch("SET_MARKERS",context.markers);
            }
        
        }

    }
</script>